import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { logoutAction } from '../../store/actions/loginAction';

import SideBar from './SideBar';

import User, { GhaUser } from '../../models/User';

import roleConfig from '../../configs/roles';
import sideBarLinks from '../../configs/sideBarLinks';
import userRemote from '../../api/userRemote';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { receiveError } from '../../store/actions/notificationAction';
import environments from '../../configs/environments';
import queueRemote from '../../api/queueRemote';
import { setAirlinesAction, setCounterAction } from '../../store/actions/countersAction';
import Counter from '../../models/Counter';

const sidebarTimeout: number = 600; 

interface SideBarContainerProps {
  user: User;
  logoutUser: Function;
  receiveError: (error: ResponseError) => void;
  button?: boolean;
  counters: Array<Counter>;
  setCounter: (id: number) => void;
  setCounterAirlines: (airlines: string[]) => void;
  counterId: number;
};

interface SideBarContainerState {
  menuItems: Array<Array<string>>;
  checked: boolean;
  height: string;
  ghaUser: GhaUser;
  counterId: number;
  showCounter: boolean;
};

class SideBarContainer extends Component<SideBarContainerProps, SideBarContainerState> {

  state = {
    menuItems: [],
    checked: false,
    height: '0',
    ghaUser: {} as GhaUser,
    counterId: 0,
    showCounter: true
  };

  componentDidMount() {
    window.addEventListener('beforeunload', (event) => {
       this.leaveCounter();
    });
    switch (this.props.user.roleId) {
   
      case roleConfig.roleId.forwarderUser: this.setState({ menuItems: sideBarLinks.linkItems.forwarder, showCounter: false }); break;
      case roleConfig.roleId.ghaOffice: this.setState({ menuItems: sideBarLinks.linkItems.ghaOffice }); break;
      case roleConfig.roleId.ghaWarehouse: this.setState({ menuItems: sideBarLinks.linkItems.ghaWhs, showCounter: false }); break;
      case roleConfig.roleId.forwarderAdmin: this.setState({ menuItems: sideBarLinks.linkItems.fwdAdmin }); break;
      case roleConfig.roleId.ghaAdmin: this.setState({ menuItems: sideBarLinks.linkItems.ghaAdmin }); break;
      case roleConfig.roleId.ghaSupervisor: this.setState({ menuItems: sideBarLinks.linkItems.ghaSupervisor }); break;
      case roleConfig.roleId.ghaManager: this.setState({ menuItems: sideBarLinks.linkItems.ghaManager }); break;
      case roleConfig.roleId.ghaAccounting: this.setState({ menuItems: sideBarLinks.linkItems.ghaAccounting, showCounter: false }); break;
      case roleConfig.roleId.ghaScreener: this.setState({ menuItems: sideBarLinks.linkItems.ghaScreener, showCounter: false }); break;
      case roleConfig.roleId.ghaWarehouseScreener: this.setState({ menuItems: sideBarLinks.linkItems.ghaWarehouseScreener, showCounter: false }); break;
      case roleConfig.roleId.ghaDashboard: this.setState({ menuItems: sideBarLinks.linkItems.ghaDashboard }); break;
      case roleConfig.roleId.ghaAirlineRepresentative: this.setState({ menuItems: sideBarLinks.linkItems.ghaAirlineRepresentative, showCounter: false }); break;
      case roleConfig.roleId.ghaOfflineRFSRep: this.setState({ menuItems: sideBarLinks.linkItems.ghaOfflineRFSRep }); break;
      case roleConfig.roleId.ghaManagerWh: this.setState({ menuItems: sideBarLinks.linkItems.ghaManagerWh, showCounter: false }); break;
      case roleConfig.roleId.ghaSupervisorWh: this.setState({ menuItems: sideBarLinks.linkItems.ghaSupervisorWh, showCounter: false }); break;
      case roleConfig.roleId.superUser: this.setState({ menuItems: sideBarLinks.linkItems.superUser }); break;
      case roleConfig.roleId.laxOfficeAgent: this.setState({ menuItems: sideBarLinks.linkItems.laxOfficeAgent }); break;
      case roleConfig.roleId.ghaAccReco: this.setState({ menuItems: sideBarLinks.linkItems.ghaAccReco, showCounter: false }); break;

      default: break;
    }
    this.setUserRole();

  }

  componentDidUpdate(prevProps: SideBarContainerProps) {
   if(prevProps.user !== this.props.user) {
     this.setUserRole();
    }
    
  }
  
  menuEvent = (event: any): void => {

    if (event.target.nodeName === 'A') {
      this.handleChange();
      window.scrollTo(0, 0)
    }
  }

  openShuttleTracker = (event: any): void => {
    if(this.state.ghaUser) {
      let safariWindow = window.open();
      let data = { userId: this.state.ghaUser.userId }
      userRemote.getUuid(data).then((res: ApiResponse<any>) => {
        const result: any | undefined = res.result;
        const error: ResponseError | undefined = res.error;
  
        if (result) {
          let query = `?uuid=${result.uuid}`;
          let shuttleTrackerUri = environments.shuttleTrackerUri.concat(query);
          if(safariWindow) {
            safariWindow.location.href = shuttleTrackerUri;
          }
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
  }

  handleChange = (): void => {

    const checked: boolean = !this.state.checked;

    this.setState({ checked: checked });

    if(checked) {
      this.setState({ height: 'auto' });
      document.body.style.overflow = 'hidden';
    } else {
      setTimeout(() => {
        this.setState({ height: '0' });
        document.body.style.overflow = 'unset';
      }, sidebarTimeout);
    }
  }

  setUserRole = (): void => {
    const value = localStorage.getItem('user');
    if(value) {
      const user = JSON.parse(value);
      this.setState({ ghaUser: user });
    }
  }

  setCounter = (event: any): void => {
    if( event.target) {
      const id = event.target.value;
      queueRemote.selectCounter(id).then((res: ApiResponse<any>) => {
        const result: any | undefined = res.result;
        const error: ResponseError | undefined = res.error;
  
        if (result) {
          this.props.setCounter(result.id);

          if(result.info && result.info.airlines) {
            this.props.setCounterAirlines(result.info.airlines);
          } else {
            this.props.setCounterAirlines([]);
          
          }
        }
        if(result == null) {
          this.props.setCounter(0);
          this.props.setCounterAirlines([]);
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
    
  }

  leaveCounter = (): void => {
    queueRemote.leaveCounter().then((res: ApiResponse<any>) => {
      const result: any | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (result) {
        
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  signOut = (): void => {
    this.props.logoutUser();
  }

  render() {
    
    return (
      <Fragment>
        { this.state.menuItems.length > 0 &&
          <SideBar
            menuItems={ this.state.menuItems }
            sidebarTimeout={ sidebarTimeout }
            checked={ this.state.checked }
            handleChange={ this.handleChange }
            user={ this.props.user }
            signOut={ this.signOut }
            menuEvent={ this.menuEvent }
            height={ this.state.height }
            ghaUser={ this.state.ghaUser }
            openShuttleTracker={ this.openShuttleTracker }
            button={ this.props.button }
            counters={ this.props.counters }
            counterId={ this.props.counterId }
            selectCounter={ this.setCounter }
            showCounter={ this.state.showCounter }
          />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    counters: state.countersAvailable,
    counterId: state.userCounter,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    logoutUser: () => dispatch(logoutAction()),
    setCounter: (counterId: number) => dispatch(setCounterAction(counterId)),
    setCounterAirlines: (airlines: string[]) => dispatch(setAirlinesAction(airlines))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBarContainer);